module.exports = __webpack_public_path__ + "static/media/Exam_T&C.8a38845d.pdf";